<template>
  <div :style="{height:height+'px',width:width+'px',overflow:'hidden'}">
    <div
      class="left"
      :style="{height:height+'px',width:menu_width+'px',overflow:'hidden',float:'left' }"
    >
      <menu :height="height" :width="menu_width"></menu>
      <div class="systemInfo">
        <div style="margin-bottom: 30px;color: #81cef2;">{{user_info.username}}</div>
        <div
          v-for="(menu,index) in menus"
          :key="index"
          :class="'category_btn' + (current_menu_index === index ? ' typeSelected':'')"
          @click="menu_click(index)"
        >
          {{menu.name}}
          <span
            v-if="approval_counts > 0 && approval_counts < 10 && menu.name === '审批' "
            class="approvalCounts approvalCounts2 count_wrapper"
          >{{approval_counts}}</span>
          <span
            v-if="approval_counts > 9 && approval_counts < 99 && menu.name === '审批' "
            class="approvalCounts approvalCounts2 count_wrapper"
          >{{approval_counts}}</span>
          <span
            class="approvalCounts approvalCounts3 count_wrapper"
            v-if="approval_counts > 99 && menu.name === '审批' "
          >{{approval_counts}}</span>
        </div>
        <div class="category_btn" @click="loginout">退出</div>
        <div class="downloadTips">
          <div>安装安卓白马</div>
          <div>项目管理APP</div>
          <img :src="appUrl" alt class="appUrl" />
        </div>
      </div>
    </div>
    <div
      :style="{height:height+'px',width:(width - menu_width)+'px',overflow:'hidden',float:'left' }"
    >
      <router-view :height="height" :width="width - menu_width"></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menus: [
        { link: "/main/project/welcome", name: "项目" },
        // { link: "/main/auditing/welcome", name: "审批" }
        { link: "/main/auditing/welcome", name: "审批" }
      ],
      current_menu_index: -1,
      user_info: null,
      web_token: null,
      web_url: null,
      appUrl: null,
      upload_url: null,
      menu_width: 100,
      approval_counts: 0
    };
  },
  props: ["height", "width"],
  created() {
    this.ready();
  },
  mounted() {
    this.menu_init();
    this.approval_count();
  },
  methods: {
    ready: function() {
      this.web_token = sessionStorage.getItem("web_token");
      this.user_info = JSON.parse(sessionStorage.getItem("user_info"));
      this.web_url = sessionStorage.getItem("web_url");

      this.appUrl = this.web_url + "/download_apk.png";
      this.upload_url = this.web_url + "/document/add";
    },
    //  获取审批数量
    approval_count() {
      this.$http
        .post(
          this.web_url + "/approval/count",
          { web_token: this.web_token },
          { emulateJSON: true }
        )
        .then(function(res) {
          this.approval_counts = res.data.data.approval_count;
        })
        .catch(function(res1) {
          console.log(res1);
        });
    },
    menu_init: function() {
      var router_name = this.$route.name;
      console.log(router_name);
      for (var i = 0; i < this.menus.length; i++) {
        if (router_name.indexOf(this.menus[i].name) >= 0) {
          this.current_menu_index = i;
          break;
        }
      }
    },
    //退出登录
    loginout: function() {
      this.$http
        .post(
          this.web_url + "/logout",
          { web_token: this.web_token, system: "web", model_id: "6" },
          { emulateJSON: true }
        )
        .then(function(res) {
          if (res.data.status == "ok") {
            sessionStorage.removeItem("user_info");
            sessionStorage.removeItem("web_token");
            this.$router.push({ path: "/login" });
          } else {
          }
        })
        .catch(function(res1) {
          console.log(res1);
        });
    },
    menu_click: function(_index) {
      var menu = this.menus[_index];
      this.current_menu_index = _index;
      this.$router.push({ path: menu.link });
      console.log(menu.link);
    }
  }
};
</script>

<style scoped>
.left {
  background-color: #366c9b;
}
.systemInfo {
  padding-top: 10px;
  text-align: center;
  color: #fff;
}
.systemInfo .category_btn {
  line-height: 28px;
  margin: 8px;
  width: 60px;
  background: transparent;
  position: relative;
}
.systemInfo .typeSelected {
  background: #4589c8 !important;
}
.count_wrapper {
  position: absolute;
  right: -5px;
  top: -10px;
}
.approvalCounts {
  display: inline-block;
  width: 16px;
  height: 18px;
  line-height: 18px;
  font-size: 11px;
  background: #ff0000;
  color: #fff;
  font-weight: bold;
  text-align: center;
  border-radius: 12px;
}
.approvalCounts2 {
  width: 22px;
  height: 22px;
  line-height: 22px;
  font-size: 11px;
}
.approvalCounts3 {
  width: 28px;
  height: 28px;
  line-height: 28px;
  font-size: 8px;
}
</style>



// WEBPACK FOOTER //
// src/page/main.vue